'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$186() {
  this.cef = null;
  this.ced = null;
  this.cee = false;
  this.ceb = null;
  this.cec = false;
  this.ceg = false;
  this.ceh = false;
  this.cef = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$$anon$186 as $c_Lpresto_types$proto$$anon$186 };
$p = $c_Lpresto_types$proto$$anon$186.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$186;
/** @constructor */
function $h_Lpresto_types$proto$$anon$186() {
}
export { $h_Lpresto_types$proto$$anon$186 as $h_Lpresto_types$proto$$anon$186 };
$h_Lpresto_types$proto$$anon$186.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.cef;
});
$p.t = (function() {
  if ((!this.cee)) {
    this.ced = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ip", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cee = true;
  }
  return this.ced;
});
$p.ad = (function() {
  if ((!this.cec)) {
    this.ceb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().a2r(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cec = true;
  }
  return this.ceb;
});
$p.v = (function() {
  if ((!this.ceh)) {
    this.ceg = false;
    this.ceh = true;
  }
  return this.ceg;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$$anon$186 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$186, "presto.types$proto$$anon$186", ({
  a3j: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$$anon$186 as $d_Lpresto_types$proto$$anon$186 };
//# sourceMappingURL=presto.types$proto$$anon$186.js.map
